import { Link } from "react-router-dom";
import tiltifyLogo from "../../css/images/tiltify-logo.svg";
import tiltifyLogoWhite from "../../css/images/tiltify-logo-white.svg";
import { ThemeToggle } from "../ThemeToggle";

// Brand marks from Simple Icons (CC0, simpleicons.org), drawn in currentColor
// so they follow the nav link colors.
const SOCIAL_LINKS = [
  {
    name: "Twitch",
    href: "https://www.twitch.tv/tiltify",
    path: "M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z",
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/c/tiltifytv",
    path: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
  },
  {
    name: "Discord",
    href: "https://discord.gg/tiltify",
    path: "M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z",
  },
];

export const Layout = ({ children }) => {
  return (
    <>
      <header className="menu-wrapper">
        <div className="menu-inner">
          <div className="menu-x-inner flex justify-between items-center py-6">
            <Link to="/" className="logo-wrapper">
              {/* Blue logo on light, white logo on the dark theme (index.css). */}
              <img src={tiltifyLogo} alt="Tiltify Blog" className="site-logo site-logo-light" width="480" height="105" />
              <img src={tiltifyLogoWhite} alt="Tiltify Blog" className="site-logo site-logo-dark" width="480" height="105" />
            </Link>
            <nav aria-label="Main">
              <ul className="site-nav">
                {SOCIAL_LINKS.map((social) => (
                  <li key={social.name}>
                    <SocialLink {...social} />
                  </li>
                ))}
                <li>
                  <a href="https://info.tiltify.com">Support</a>
                </li>
                <li>
                  <a href="https://start.tiltify.com" className="site-nav-cta">
                    Start Fundraising
                  </a>
                </li>
              </ul>
            </nav>
            <ThemeToggle />
          </div>
        </div>
      </header>

      {children}

      <footer className="site-footer">
        <div className="site-footer-inner">
          <div className="site-footer-top">
            <Link to="/" className="site-footer-logo">
              <img src={tiltifyLogo} alt="Tiltify Blog" className="site-logo site-logo-light" width="480" height="105" />
              <img src={tiltifyLogoWhite} alt="Tiltify Blog" className="site-logo site-logo-dark" width="480" height="105" />
            </Link>
            <ul className="site-footer-social" aria-label="Tiltify on social media">
              {SOCIAL_LINKS.map((social) => (
                <li key={social.name}>
                  <SocialLink {...social} />
                </li>
              ))}
            </ul>
          </div>
          <div className="site-footer-bottom">
            <p>&copy; Tiltify {new Date().getFullYear()}</p>
            <ul className="site-footer-links">
              <li>
                <a href="https://info.tiltify.com">Support</a>
              </li>
              <li>
                <a href="https://tiltify.com/pages/terms-of-service" target="_blank" rel="noreferrer">
                  Terms
                </a>
              </li>
              <li>
                <a href="https://tiltify.com/pages/privacy-policy" target="_blank" rel="noreferrer">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
};

const SocialLink = ({ name, href, path }) => (
  <a href={href} className="site-nav-icon" aria-label={name} title={name} target="_blank" rel="noreferrer">
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d={path} fill="currentColor" />
    </svg>
  </a>
);
